import Settings from '@mui/icons-material/Settings'
import { Avatar } from '@mui/material'
import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { useSelector } from 'react-redux'

import { ModalHeader } from '@/components/Modal'
import { selectCalendarRangeInterval } from '@/features/domain/ui'
import { useFormatDateInterval } from '@/hooks'

import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

interface Props {
  /** Complete screen: hide the avatar/title and show only an X close button. */
  showClose?: boolean
}

export function Header({ showClose = false }: Props) {
  const texts = useTexts()
  const { close } = useController()
  const { start, end } = useSelector(selectCalendarRangeInterval)

  const interval = useFormatDateInterval(start, end, false, true)

  // Complete screen: no avatar/title — just a close button.
  if (showClose) {
    return (
      <ModalHeader
        title={false}
        actions={[
          <ActionBarItem
            icon={<Close />}
            testId="build-progress__close"
            key="close"
            onClick={close}
            label=""
          />,
        ]}
      />
    )
  }

  const isMultiDay = start.getTime() !== end.getTime()
  const title = isMultiDay ? texts.titleWithRange(interval) : texts.title

  return (
    <ModalHeader
      avatar={
        <Avatar
          sx={{
            bgcolor: t => t.vars.palette.action.hover,
            color: t => t.vars.palette.action.active,
            width: 40,
            height: 40,
          }}
        >
          <Settings fontSize="medium" />
        </Avatar>
      }
      title={title}
    />
  )
}
